module.exports = window.deck;